import axios from 'axios'
import { notifySuccess } from 'utils/common'
import { MessageBox } from 'element-ui'

class User {
  constructor (data) {
    this.id = data.id
    this.username = data.username // string 用户名
    this.nickname = data.nickname // string 昵称
    this.isLocked = Boolean(data.locked) // boolean 锁定状态
    this.isSuperAdmin = Boolean(data.superAdmin) // boolean 是否为超级管理员
  }
}

/**
 * 获取用户列表，作为下拉选项
 * @returns {Array}
 */
export const getOptions = async () => {
  const { data } = await axios.get('v1/users/listAll')
  return data.map(item => {
    return {
      label: item.nickname, // string
      value: item.username // string
    }
  })
}

/**
 * 获取用户列表，服务器分页
 * @param {*Number} pageNo 当前页
 * @param {*Number} pageSize 每页条数
 * @return {Array}
 */
export const getList = async (params) => {
  const { data: { records, recordCount } } = await axios.get('v1/users', { params })
  const list = records.map(item => new User(item))
  return { total: recordCount, list }
}

/**
 * 新增用户
 * @param {*Object} data
 */
export const create = async (data) => {
  await axios.post('v1/users', data)
  notifySuccess('新增成功')
}

/**
 * 解锁用户
 * @param {*Number} userId 用户id
 */
export const unlock = async (userId) => {
  await axios.post(`v1/users/${userId}/unlock`)
  notifySuccess('解锁成功')
}

/**
 * 锁定用户
 * @param {*Number} userId 用户id
 */
export const lock = async (userId) => {
  await axios.post(`v1/users/${userId}/lock`)
  notifySuccess('锁定成功')
}

/**
 * 锁定和解锁用户合并一起的方法
 * @param {*Number} userId 用户id
 * @param {*String} action 执行动作，lock-锁定 unlock-解锁
 */
export const changeState = async (userId, action) => {
  const map = {
    lock: lock,
    unlock: unlock
  }
  const handler = map[action]
  if (typeof handler !== 'function') {
    throw new Error('调用方法错误')
  }
  await handler(userId)
}

/**
 * 重置密码
 * @param {*Number} userId 用户id
 */
export const resetPassword = async (userId) => {
  let {data: {detail}} = await axios.post(`v1/users/${userId}/password/reset`)
  notifySuccess('重置密码成功')
  MessageBox.alert(`${detail}`, '新密码', {
    confirmButtonText: '确定'
  })
}

/**
 * 修改密码
*/
export const resetPasswordSelf = async (options) => {
  console.log('reset')
  console.log(options)
  let {data} = await axios.post(`/v1/me/password`, {
    oldPassword: options.oldPassword,
    newPassword: options.newPassword
  })
  return data
}
